import { Badge, Grid, Paper, Space, Text } from '@mantine/core';

import { useGetProphetStats } from '../../api/getStats';
import { prophetTypes } from '../../types';

// Spreading undefined into an object is safe; keys keep their order:
// first the arrival keywords, then the new ones from spreadKeywords.
const keywordWords = (s: prophetTypes.Stats) => Object.keys({ ...s.keywords, ...s.spreadKeywords });

export const Stats = ({ pageId }: { pageId: string }) => {
  const { data } = useGetProphetStats({ pageIds: [pageId], date: null });
  const stats = data?.stats || [];

  return (
    <>
      <Grid columns={2}>
        {stats.map((s) => {
          const words = keywordWords(s);
          return (
            <Grid.Col key={s._id} span={1}>
              <Paper shadow="md" radius="md" p="md">
                <Text>{s.date.replaceAll('/', '.')}</Text>
                <Space h="xs" />
                <Badge variant="light" color="teal" mr="xs" mb="xs" radius="md">
                  Новых: {s.newDialogs}
                </Badge>
                <Badge variant="light" color="blue" mr="xs" mb="xs" radius="md">
                  Принято: {s.accepted}
                </Badge>
                <Badge variant="light" color="blue" mr="xs" mb="xs" radius="md">
                  Раскладов: {s.spreads}
                </Badge>
                <Badge variant="light" color="blue" mr="xs" mb="xs" radius="md">
                  Пинков на расклад: {s.spreadKicks || 0}
                </Badge>
                <Badge variant="light" color="blue" mr="xs" mb="xs" radius="md">
                  Скидок: {s.discounts}
                </Badge>
                <Badge variant="light" color="blue" mr="xs" mb="xs" radius="md">
                  Возражений: {s.refuses}
                </Badge>
                <Badge variant="light" color="blue" mr="xs" mb="xs" radius="md">
                  Менеджеру: {s.sentToManager}
                </Badge>
                <Badge variant="light" color="pink" mr="xs" mb="xs" radius="md">
                  Архив: {s.removed}
                </Badge>
                {words.length > 0 && (
                  <>
                    <Text>Кодовые (пришло → расклад)</Text>
                    <Space h="xs" />
                    {words.map((keyword) => (
                      <Badge
                        variant="light"
                        color="violet"
                        key={keyword}
                        mr="xs"
                        mb="xs"
                        radius="md"
                      >
                        {keyword}: {s.keywords?.[keyword] ?? 0} → {s.spreadKeywords?.[keyword] ?? 0}
                      </Badge>
                    ))}
                  </>
                )}
              </Paper>
            </Grid.Col>
          );
        })}
      </Grid>
    </>
  );
};
